import { useMemo } from 'react';

import { replaceDistanceChar } from '../utils/replace-distance-char';

export const useRoundDistance = (
  num: number,
): string => useMemo(() => replaceDistanceChar(num?.toFixed(1)), [num]);
